import { useCallback } from 'react';

import { useAuthUser } from 'auth/hooks';
import { localStorage } from 'core/utils';

export const useLocalStorage = () => {
  const { user } = useAuthUser();

  const userId = user?.id || '';

  const saveObject = useCallback(
    (key: string, data: unknown, expirationTimeInMs?: number) => {
      localStorage.saveObject(`${key}_${userId}`, data, expirationTimeInMs);
    },
    [userId]
  );

  const getObject = useCallback(
    <T = unknown>(key: string): T | null => {
      return localStorage.getObject<T>(`${key}_${userId}`);
    },
    [userId]
  );

  return {
    saveObject,
    getObject,
  };
};
